interface Country {
  name: string;
  code: string;
}

export const getSortedTimezones = (timezoneslist: string[]) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const sortedTimeZones = [...timezoneslist.sort()];
  if (sortedTimeZones.includes(timezone)) {
    const currentTimeZoneIndex = sortedTimeZones.indexOf(timezone);
    const currentTimeZone = sortedTimeZones
      .splice(currentTimeZoneIndex, 1)
      .pop();
    sortedTimeZones.unshift(currentTimeZone ?? '');
  }
  return sortedTimeZones.map(tz => ({
    label: tz.replace(/_/g, ' ').replace(/\//g, ' - '), // Convert "America/New_York" to "America - New York"
    value: tz
  }));
};

export const getSortedCountries = (countries: Country[]) => {
  // Get user's language to guess their country
  const userLanguage = navigator.language || navigator.languages[0];
  const countryCode = userLanguage.split('-')[1]?.toUpperCase();

  const sortedCountries = [...countries].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  if (
    countryCode &&
    sortedCountries.some(country => country.code === countryCode)
  ) {
    const currentCountryIndex = sortedCountries.findIndex(
      country => country.code === countryCode
    );
    const currentCountry = sortedCountries.splice(currentCountryIndex, 1)[0];
    sortedCountries.unshift(currentCountry);
  }

  return sortedCountries.map(country => ({
    label: country.name,
    value: country.code
  }));
};
